export default __webpack_public_path__ + "static/media/c2.c5244c35.png";